<template>
  <b-card title="Histórico Inválidos">
    <div class="d-flex justify-content-end mb-2">
      <b-button
        variant="primary"
        size="sm"
        @click="handleDeleteAll"
      >
        <b-icon-trash class="mr-1" />
        Excluir todos
      </b-button>
    </div>
    <div v-if="loading" class="text-center py-3">
      <b-spinner label="Carregando..." />
    </div>

    <b-table
      v-else-if="formattedItems.length > 0"
      striped
      hover
      :per-page="perPage"
      :current-page="currentPage"
      :items="formattedItems"
      :fields="fields"
    >
      <template #cell(actions)="row">
        <b-button
          size="sm"
          variant="light"
          @click="handleDelete(row.item)"
        >
          <b-icon-trash />
        </b-button>
      </template>
    </b-table>

    <div v-else class="text-center py-4 text-muted">
      Nenhum registro encontrado
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="items.length"
      :per-page="perPage"
      align="center"
      class="mt-3"
    />

  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BTable,
  BPagination,
  BSpinner,
  BIconTrash 
} from "bootstrap-vue";

import { DateTime } from "luxon";

export default {
  components: {
    BCard,
    BButton,
    BTable,
    BPagination,
    BSpinner,
    BIconTrash 
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    meta: Object,
    loading: Boolean,
  },

  data() {
    return {
      currentPage: 1,
      perPage:10,
      fields: [
        { key: "merchant_name", label: "Nome PV", sortable: true  },
        { key: "legal_name", label: "Razão Social" , sortable: true },
        { key: "category", label: "Categoria" },
        { key: "document", label: "CPF/CNPJ" },
        { key: "date", label: "Data", sortable: true  },
        { key: "cancellation_reason", label: "Motivo" },
        { key: "actions", label: "Ações" }, 
      ],
    };
  },

 computed: {
  formattedItems() {
    return this.items.map((item) => ({
      merchant_name: item.merchant_name || "-",
      legal_name: item.legal_name || "-",
      category: item.category || "-",
       document: this.formatDocument(item.document) || "-",
      date: item.date
        ? DateTime.fromISO(item.date).toFormat("dd/MM/yyyy")
        : "-",
      cancellation_reason: item.cancellation_reason || "-",
    }));
  },
},

  methods: {
      async handleDelete(item) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          "Tem certeza que deseja excluir este registro?",
          {
            title: "Confirmação",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Sim, excluir",
            cancelTitle: "Cancelar",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );

        if (!confirmed) return;

        this.$emit("delete-item", item);
      },
      async handleDeleteAll() {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          "Tem certeza que deseja excluir TODOS os registros inválidos?",
          {
            title: "Confirmação",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Sim, excluir tudo",
            cancelTitle: "Cancelar",
            centered: true,
          }
        );

        if (!confirmed) return;

        this.$emit("delete-all-invalid");
      },
     formatDocument(value) {
      const numbers = String(value).replace(/\D/g, '');

      if (numbers.length === 11) {
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (numbers.length === 14) {
        return numbers.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '$1.$2.$3/$4-$5'
        );
      }
      return value; 
    }
  },
};
</script>